import type { StaticLayerPayload } from "@config";
import { AnimatedImageLibrary } from "@library-elements/animated-image";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: AnimatedImageLibrary,
};

export const AnimatedImage = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
